/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignIdRunBody model module.
 * @module model/CampaignIdRunBody
 * @version 1.0.0
 */
export class CampaignIdRunBody {
  /**
   * Constructs a new <code>CampaignIdRunBody</code>.
   * @alias module:model/CampaignIdRunBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignIdRunBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignIdRunBody} obj Optional instance to populate.
   * @return {module:model/CampaignIdRunBody} The populated <code>CampaignIdRunBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignIdRunBody();
      if (data.hasOwnProperty('reprocess'))
        obj.reprocess = ApiClient.convertToType(data['reprocess'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} reprocess
 */
CampaignIdRunBody.prototype.reprocess = undefined;

